'use client';

import useSyndecaShopLayer from '@/hooks/useSyndecaShopLayer';
const SyndecaShopLayer = () => {
  useSyndecaShopLayer();
  return null;
};
export default SyndecaShopLayer;